<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            defaultFontSize: 10,
            fontColor: 'black'
          },
          display: false
        },

        scales: {
          yAxes: [
            {
              ticks: {
                display: true,
                beginAtZero: true,
                fontSize: 12,
                stepSize: 5,
                suggestedMax: 10,
                padding: 0
              },
              gridLines: {
                zeroLineColor: '#232220',
                zeroLineWidth: 1,
                display: true,
                drawBorder: false,
                lineWidth: 1,
                color: 'transparent'
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 0,
                fontSize: 12
              },
              gridLines: {
                zeroLineColor: '#232220',
                zeroLineWidth: 1,
                display: true,
                drawBorder: false,
                lineWidth: 1,
                color: 'transparent'
              }
            }
          ]
        }
      }
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontColor = '#25282a'
    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontFamily = 'Nunito Sans'
    // eslint-disable-next-line no-undef
    Chart.defaults.global.defaultFontSize = 10

    this.renderChart(this.chartdata, this.options)
  }
}
</script>
